var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageMultiIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2H20.5H22V3.5V18H20.5V3.5H6V2ZM3 21H19V5H3V21ZM4.5 14.4L7.46 11.44L11.5 15.48L7.48 19.5H4.49V14.4H4.5ZM9.61 19.5L14.5 14.61L17.5 17.62V19.5H9.61ZM17.5 6.5V15.5L14.5 12.49L12.57 14.42L7.47 9.32L4.51 12.28V6.5H17.5ZM13.4402 12.1801C14.8302 12.1801 15.9702 11.0501 15.9702 9.65012C15.9702 8.25012 14.8402 7.12012 13.4402 7.12012C12.0402 7.12012 10.9102 8.25012 10.9102 9.65012C10.9102 11.0501 12.0402 12.1801 13.4402 12.1801ZM13.4402 8.63012C14.0102 8.63012 14.4702 9.09012 14.4702 9.66012C14.4702 10.2301 14.0102 10.6901 13.4402 10.6901C12.8702 10.6901 12.4102 10.2301 12.4102 9.66012C12.4102 9.09012 12.8702 8.63012 13.4402 8.63012Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageMultiIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Image_Multi_icon.3eed064486a34a6ebccc31b74e3ab044.svg";